<template>
  <div v-if="show">
    <el-cascader
      ref="cascader"
      style="width:100%;"
      v-model="selecteds"
      :clearable="clearable"
      :filterable="filterable"
      :props="vprops"
      :disabled="disabled"
      @change="onChange"
      :placeholder="
        placeholderText == ''
          ? $l('form_label_please_select_your_region') || '请选择所在地区'
          : placeholderText
      "
    ></el-cascader>
  </div>
  <div v-else>
    <el-input style="width:100%;"></el-input>
  </div>
</template>
<script>
import { request } from '@/api/service'
export default {
  props: {
    show: Boolean,
    props: { type: Object, default: () => {} },
    provinceCode: String,
    provinceName: String,
    cityCode: String,
    cityName: String,
    districtCode: String,
    districtName: String,
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      selecteds: null,
      vprops: {
        lazy: true,
        lazyLoad: (node, resolve) => this.lazyLoadData(node, resolve),
        ...this.props,
      },
    }
  },
  computed: {
    placeholderText() {
      return [this.provinceName, this.cityName, this.districtName]
        .filter(Boolean)
        .join(' / ')
    },
  },
  watch: {
    provinceCode: {
      handler(val) {
        if (val) {
          this.selecteds = [this.provinceCode, this.cityCode, this.districtCode]
        }
      },
      immediate: true,
    },
  },
  methods: {
    onExpandChange(val) {
      console.log(val)
    },
    onChange() {
      const checkedNodes = this.$refs.cascader.getCheckedNodes()
      if (!checkedNodes || !checkedNodes.length) {
        this.clearValue()
        return
      }

      if (this.multiple) {
        this.multipleChange(checkedNodes)
        return
      }

      const checkedNode = checkedNodes[0] || {}
      const pathNodes = checkedNode.pathNodes || []
      if (!pathNodes || !pathNodes.length) {
        this.clearValue()
      }
      if (pathNodes[0]) {
        this.$emit('update:provinceCode', pathNodes[0].value)
        this.$emit('update:provinceName', pathNodes[0].label)
      } else {
        this.$emit('update:provinceCode', null)
        this.$emit('update:provinceName', null)
      }
      if (pathNodes[1]) {
        this.$emit('update:cityCode', pathNodes[1].value)
        this.$emit('update:cityName', pathNodes[1].label)
      } else {
        this.$emit('update:cityCode', null)
        this.$emit('update:cityName', null)
      }
      if (pathNodes[2]) {
        this.$emit('update:districtCode', pathNodes[2].value)
        this.$emit('update:districtName', pathNodes[2].label)
      } else {
        this.$emit('update:districtCode', '')
        this.$emit('update:districtName', '')
      }
    },

    getCheckedNodes() {
      return this.$refs.cascader.getCheckedNodes()
    },

    multipleChange(nodes) {
      let provinceCodeList = []
      let cityCodeList = []
      let districtCodeList = []

      nodes.forEach((node) => {
        const { level, value } = node
        if (level === 1) provinceCodeList.push(value)
        if (level === 2) cityCodeList.push(value)
        if (level === 3) districtCodeList.push(value)
      })

      this.$emit('multipleChange', {
        provinceCodeList,
        cityCodeList,
        districtCodeList,
      })
    },

    clearValue() {
      this.selecteds = null
      if (this.multiple) {
        this.$emit('multipleChange', {
          provinceCodeList: [],
          cityCodeList: [],
          districtCodeList: [],
        })
        return
      }
      this.$emit('update:provinceCode', '')
      this.$emit('update:provinceName', '')
      this.$emit('update:cityCode', '')
      this.$emit('update:cityName', '')
      this.$emit('update:districtCode', '')
      this.$emit('update:districtName', '')

      if (this.multiple) {
        this.$emit('multipleChange', {
          provinceCodeList: [],
          cityCodeList: [],
          districtCodeList: [],
        })
      }
    },

    async lazyLoadData(node, resolve) {
      const { value } = node
      const nodes = await this.getData({ id: value })
      resolve(nodes)
    },

    getData(params) {
      return this.getApi(params).then((res) => {
        return res.body.data
      })
    },

    getApi(params) {
      return request({
        url: '/sys/region/select',
        method: 'GET',
        params,
      })
    },
  },
}
</script>
